/* ==========================================================================
   boyin-filter-grid.js
   Beauty By Boyin — /treatments filter bar (Brief Section 08).

   "Filter bar (Lashes / Brows / PMU / Facials / Combos)."

   Client-side filtering over cards already in the DOM — no network request,
   no reload. Every card is server-rendered, so with JS disabled the page
   simply shows all treatments, which is a perfectly good page.
   ========================================================================== */

class BoyinFilterGrid extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-filter]'));
    this.cards = Array.from(this.querySelectorAll('[data-categories]'));
    this.status = this.querySelector('[data-filter-status]');
    this.empty = this.querySelector('[data-empty]');
    if (!this.buttons.length || !this.cards.length) return;

    // The bar is useless without JS, so it ships hidden and is revealed here.
    this.querySelector('[data-filter-bar]')?.removeAttribute('hidden');

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.apply(btn.dataset.filter));
    });

    this.apply('all');
  }

  apply(filter) {
    let shown = 0;

    this.cards.forEach((card) => {
      // Categories are space-separated handles on the card, e.g. "lashes combos".
      const cats = (card.dataset.categories || '').split(/\s+/).filter(Boolean);
      const match = filter === 'all' || cats.includes(filter);
      // `hidden` rather than display:none — it removes the card from the
      // accessibility tree too, so screen readers don't read filtered-out cards.
      card.hidden = !match;
      if (match) shown += 1;
    });

    this.buttons.forEach((btn) => {
      const active = btn.dataset.filter === filter;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (this.empty) this.empty.hidden = shown > 0;

    if (this.status) {
      this.status.textContent =
        shown === 1 ? '1 treatment shown' : `${shown} treatments shown`;
    }
  }
}

if (!customElements.get('boyin-filter-grid')) {
  customElements.define('boyin-filter-grid', BoyinFilterGrid);
}
